import { WitaConnector } from '@/services/repository/connector'

import { TodoRepositoryProps } from './Todo.d'

const ROOT_URL = '/administrative'

export const TodoRepository = {
  GetTodos: async function ({ userId }: TodoRepositoryProps.GetTodos.Params) {
    const url = ROOT_URL + `/list/${userId}`
    return await WitaConnector.get<TodoRepositoryProps.GetTodos.Response>(url)
  },
}
